<script lang="ts" setup>
import type { ConcreteComponent } from 'vue'
import type { Skill } from '@prisma/client'
import { storeToRefs } from 'pinia'
import { useSkill } from '~/store/skill'
import { Iconify } from '~/types/assets'

const skill = useSkill()
const { query } = useRoute()

const { skills } = storeToRefs(skill)

const SkillCard = markRaw(resolveComponent('LazyCardSkill') as ConcreteComponent)

const gammaSkills = computed(() => skills.value.filter((skill: Skill) => skill?.position === 3))
</script>

<template lang="pug">
section.skills__gamma
  h3 {{ $t('skills.gamma.title') }}
  .skills__gamma__desktop
    Icon(v-for="n in 4" :key="n" :name="Iconify?.gear")
    .skills__gamma__desktop__card(
      v-for="(_skill, index) in gammaSkills"
      :key="`skill-${index}`"
    )
      CardSkill(:skill="_skill", :open-on-mount="query?.skill === _skill?.slug")
  .skills__gamma__mobile
    UISlider(
      :component="SkillCard",
      :slides="skills",
      :fade="true"
      :auto-play="false"
      :parallax="false"
      :perspective="false"
      slide-classes="px-4"
    )
</template>

<style lang="sass" scoped>
section.skills__gamma
  @apply w-full h-full flex-center flex-col
  h3
    @apply text-primary text-2xl xl:text-3xl mb-8 text-animated text-center font-bold
  .skills__gamma__desktop
    @apply w-full hidden lg:flex flex-wrap justify-between gap-6 relative
    span.iconify
      @apply hidden xl:flex-center absolute z-20 animate-spin-slow w-12 h-12 text-4xl bg-secondary
      &:nth-of-type(1)
        @apply -top-16 -left-8
      &:nth-of-type(2)
        @apply -top-16 -right-8
      &:nth-of-type(3)
        @apply -bottom-16 -left-8
      &:nth-of-type(4)
        @apply -bottom-16 -right-8
    .skills__gamma__desktop__card
      @apply w-2/12
  .skills__gamma__mobile
    @apply w-full flex-center lg:hidden
</style>
